import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Layers, Cloud, Box, Settings, Target, Shield } from 'lucide-react';
import { skillsData } from '../utils/mockData';

const iconMap = {
  layers: Layers,
  cloud: Cloud,
  box: Box,
  settings: Settings,
  target: Target,
  shield: Shield,
};

const Skills = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 40, scale: 0.95 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: [0.645, 0.045, 0.355, 1],
      },
    },
  };

  return (
    <section className="skills-section" id="skills">
      <div className="section-container">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          className="section-header"
        >
          <div>
            <p className="skills-eyebrow">FROM STRATEGY TO OPERATIONS</p>
            <h2 className="section-title">Focus areas</h2>
          </div>
          <p className="section-subtitle">Architecture and delivery capabilities for modernizing infrastructure, platforms and the way teams operate them.</p>
        </motion.div>

        {/* Skills Grid */}
        <motion.div
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          className="skills-grid"
        >
          {skillsData.map((skill) => {
            const IconComponent = iconMap[skill.icon];
            return (
              <motion.div
                key={skill.id}
                variants={cardVariants}
                className="skill-card"
                whileHover={{
                  y: -8,
                  transition: { duration: 0.3, ease: 'easeOut' },
                }}
              >
                <div className="skill-card-top">
                  <span className="skill-kicker">{skill.kicker}</span>
                  <div className="skill-icon-container">
                    <IconComponent className="skill-icon" size={30} />
                  </div>
                </div>
                <h3 className="skill-title">{skill.title}</h3>
                <p className="skill-description">{skill.description}</p>
                <ul className="skill-scope" aria-label={`${skill.title} capabilities`}>
                  {skill.scope.map((item) => <li key={item}>{item}</li>)}
                </ul>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
